<template>
  <b-form-select
    :id="id"
    v-model="selected"
    :disabled="disabled"
    :options="options"
    @change="onChange"
  />
</template>

<script>
/*
  The idea of duration is more flexible than that of time:
    - Negative durations are allowed
    - Durations of 24:00 or more are allowed
*/
export default {
  name: "DurationSelect",
  props: {
    start: {
      type: Object,
      default: () => ({ hours: 0, minutes: 0 }),
    },
    step: {
      type: Object,
      default: () => ({ hours: 0, minutes: 15 }),
    },
    end: {
      type: Object,
      default: () => ({ hours: 24, minutes: 0 }),
    },
    value: {
      type: Object,
      default: undefined,
    },
    id: {
      type: [String, Number],
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: this.durationToOptionValue(this.value),
    };
  },
  computed: {
    options() {
      // Don't make assumptions about units here.
      const start = this.durationToOptionValue(this.start);
      const end = this.durationToOptionValue(this.end);
      const step = this.durationToOptionValue(this.step);

      let options = [];

      let current = start;
      while (current <= end) {
        let duration = this.durationFromOptionValue(current);

        options.push({
          value: current,
          text: this.formatOption(duration),
        });

        current += step;
      }

      return options;
    },
  },
  methods: {
    /*
       Unit could be changed as anything (seconds, millisecs, etc.) as long as
       it is an integer value following the same order as duration values.
     */
    durationToOptionValue(duration) {
      return duration ? duration.hours * 60 + duration.minutes : undefined;
    },
    durationFromOptionValue(value) {
      return {
        hours: Math.floor(value / 60),
        minutes: value % 60,
      };
    },
    formatOption(duration) {
      return (
        String(duration.hours).padStart(2, "0") + ":" + String(duration.minutes).padStart(2, "0")
      );
    },
    onChange() {
      this.$emit("change", this.durationFromOptionValue(this.selected));
    },
  },
};
</script>

<style lang="scss"></style>
